import styled from '@emotion/styled';
import React from 'react';
import { MobileHeader } from './MobileHeader';
import { MobileSheet } from './MobileSheet';

const Sticky = styled.div`
  position: relative;
  width: 100%;
  z-index: 15;
  top: 0;
  @media (min-width: 950px) {
    display: none;
  }
`;

export function MobileNav({ open, items, bottomLinks }: any) {
  return (
    <>
      <Sticky>
        <MobileHeader />
        <MobileSheet open={open} items={items} bottomLinks={bottomLinks} />
      </Sticky>
    </>
  );
}
